module.exports = __webpack_public_path__ + "img/new-graduate.4951d54f.jpg";